module.exports = __webpack_public_path__ + "media/public/img/expedia-review-widget-02-9fd228f0a5a8dcdb3867c30c6b1fbcf3.svg";